import 'intersection-observer'
import { injectCssWithPrefixes } from './utils'

const nav = document.getElementsByTagName('header')[0]
const step = nav.querySelector('.step .number')

const state = {
  isNavShowing: false,
}

const listeners = {
  observer: null,
  raf: null,
}

const setupNavAnimation = () => {
  let removedInitialTransition = false
  let currentSection, previousSection

  const elements = [
    document.getElementById('banner'),
    document.getElementById('services'),
    document.getElementById('reviews'),
    document.getElementById('about'),
    document.getElementById('contact'),
  ]

  // Cache scrolling selectors and distances
  const scalerThing = nav.querySelector('.scaling-thing')
  const { top } = document.getElementById('services').getBoundingClientRect()
  const { bottom } = document.getElementById('contact').getBoundingClientRect()
  const total = bottom - top

  const animate = () => {
    cancelAnimationFrame(listeners.raf)

    if (top <= window.scrollY) {
      let percentage = (window.scrollY / total).toFixed(2)
      percentage = percentage >= 1 ? 1 : percentage
      injectCssWithPrefixes(scalerThing, [
        ['transform', `scaleY(${percentage})`],
      ])
    }

    listeners.raf = requestAnimationFrame(animate)
  }

  const updateCurrentActiveLink = id => {
    Array.from(nav.querySelectorAll('a')).forEach((el, index) => {
      const hash = el.hash.slice(1)

      if (hash === id) {
        step.innerText = `0${index + 1}`
        el.classList.add('active')
      } else {
        el.classList.remove('active')
      }
    })
  }

  listeners.observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id')
        switch (id) {
          case 'banner':
            const links = Array.from(nav.getElementsByTagName('a'))

            if (!removedInitialTransition) {
              removedInitialTransition = true
              nav.classList.remove('prevent-initial-transition')
            }

            if (entry.isIntersecting) {
              state.isNavShowing = false
              nav.classList.remove('show')
              links.forEach(link => link.setAttribute('tabindex', -1))

              injectCssWithPrefixes(scalerThing, [['transform', `scaleY(0)`]])
            } else {
              animate()

              state.isNavShowing = true
              nav.classList.add('show')
              links.forEach(link => link.setAttribute('tabindex', 0))
            }
            break
          case 'services':
          case 'reviews':
          case 'about':
          case 'contact':
            let idToUpdate
            if (entry.isIntersecting) {
              if (currentSection !== id) {
                previousSection = currentSection
                currentSection = id
                updateCurrentActiveLink(currentSection)
              }
            } else {
              if (state.isNavShowing) {
                if (currentSection === id && previousSection) {
                  currentSection = previousSection
                  updateCurrentActiveLink(currentSection)
                }
              }
            }
            break
          default:
            return
        }
      })
    },
    {
      rootMargin: window.innerWidth <= 568 ? '-150px' : '-200px',
    }
  )

  elements.forEach(element => listeners.observer.observe(element))
}

setupNavAnimation()
